import React, { useEffect } from "react";
import { globalIcons } from "../icons/ReactIcons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import "./Snackbar.css";
import { setSnackbarDetails } from "../../Redux/AuthSlice";

const Snackbar: React.FC = () => {
  const dispatch = useDispatch();

  const snackbarDetails = useSelector(
    (state: RootState) => state.Auth.snackbarDetails,
  );

  useEffect(() => {
    if (snackbarDetails.status) {
      const timer = setTimeout(() => {
        dispatch(
          setSnackbarDetails({
            status: false,
            message: "",
          }),
        );
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [snackbarDetails.status, dispatch]);

  const handleClose = () => {
    dispatch(
      setSnackbarDetails({
        status: false,
        message: "",
      }),
    );
  };

  return (
    <div className="snackbar">
      {snackbarDetails.status && snackbarDetails.message !== "" && (
        <div className={`snackbar-container ${snackbarDetails.severity}`}>
          <p>{snackbarDetails.message}</p>
          <globalIcons.CloseIcon
            className="snackbar-icon"
            onClick={handleClose}
          />
        </div>
      )}
    </div>
  );
};

export default Snackbar;
